import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Products } from "@/components/Products";
import { BitweldShowcase } from "@/components/BitweldShowcase";
import { Specifications } from "@/components/Specifications";
import { Industries } from "@/components/Industries";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { VisionMission } from "@/components/VisionMission";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const Home = () => {
  return (
    <main data-testid="landing-page" className="bg-[#0E1116] text-[#F5F1EA] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Products />
      <BitweldShowcase />
      <Specifications />
      <Industries />
      <WhyChooseUs />
      <VisionMission />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#161A21",
            color: "#F5F1EA",
            border: "1px solid rgba(184, 115, 51, 0.4)",
            borderRadius: "0px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
